const page = `

{settings}
document.title: Efter flykten - mottagandet
og.title: Efter flykten - mottagandet
og.image: http://quickshot.imgix.net/og/flyktstrommar.jpg?w=1000
og.description: Så många flyktingar har Sveriges kommuner tagit emot per 1000 invånare.
og.url: http://pejl.svt.se/efter-flykten-mottagandet/
siteCatalyst.name: efter-flykten-mottagandet
siteCatalyst.category: lyxartikel
{}

[+page]

rubrik3: Sverige – om flyktingmottagandet fick bestämma

{.iframe}
src: http://pejl.svt.se/stage/efter-flykten-kartogram/
storlek: m
height: 500px

{}

Kartan visar Sverige som ett kartogram. 
Kommunerna är förvrängda för att representera antalet personer inskrivna i Migrationsverkets mottagningssystem per 1.000 invånare i stället för den faktiskta geografiska ytan.
Klicka i kartan för att öppna det interaktiva läget – och försök hitta din egen kommun.

linje:
text:  [Martin Hedström | strong], [martin.hedstrom@svt.se | mailto:martin.hedstrom@svt.se]


{.sharebuttons}
title: Efter flykten – mottagandet
url:http://pejl.svt.se/efter-flykten-mottagandet/
{}


`;

export default page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/efter-flykten-mottagandet.js
 **/